import { ElementTypeCategoriesDto } from '@cloud-twin-v2/generated/simulation.generated.client';

export class ScenariosMetadata {
  singleId: string;
  metadata: Map<string, ElementTypeCategoriesDto[]>;

  constructor(init: Partial<ScenariosMetadata>) {
    Object.assign(this, init);
  }
}
